








































import { Vue, Component } from 'vue-property-decorator'

@Component
export default class LitElementGridsome extends Vue {
  get snippet1 () {
    return 'npm i @lanthierlabs/nutrient-label'
  }

  get snippet2 () {
    return 'yarn add @lanthierlabs/nutrient-label'
  }

  get snippet3 () {
    return '<nutrient-label title="Ratio Keto Bar (both)" servingsize="1 bar" calories="220" fat="17" saturatedfat="5" carbohydrates="5" protein="12"></nutrient-label>'
  }

  get snippet4 () {
    return `
export default function(Vue, { router, head, isClient }) {
  if (isClient) {
    const NutrientLabel = require("@lanthierlabs/nutrient-label").default;
    Vue.component("nutrient-label", NutrientLabel);  
  }
  ...`
  }
}
